import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

const ActivityChart = ({ data, title, emptyMessage = 'No activity data' }) => {
  const hasData = data && data.length > 0 && data.some(d => d.shifts > 0 || d.posts > 0);

  if (!hasData) {
    return (
      <div className="chart-card chart-card-wide">
        <h3 className="chart-title">{title}</h3>
        <div className="chart-empty">
          <span className="empty-icon">📈</span>
          <p>{emptyMessage}</p>
        </div>
      </div>
    );
  }

  const formattedData = data.map(item => ({
    ...item,
    dateLabel: formatDate(item.date)
  }));

  return (
    <div className="chart-card chart-card-wide">
      <h3 className="chart-title">{title}</h3>
      <ResponsiveContainer width="100%" height={280}>
        <AreaChart data={formattedData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorShifts" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#F7C948" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#F7C948" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorPosts" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#3B82F6" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border-secondary)" />
          <XAxis
            dataKey="dateLabel"
            stroke="var(--text-muted)"
            tick={{ fill: 'var(--text-secondary)', fontSize: 12 }}
            axisLine={{ stroke: 'var(--border-secondary)' }}
          />
          <YAxis
            stroke="var(--text-muted)"
            tick={{ fill: 'var(--text-secondary)', fontSize: 12 }}
            axisLine={{ stroke: 'var(--border-secondary)' }}
            allowDecimals={false}
          />
          <Tooltip
            contentStyle={{
              background: 'var(--bg-tertiary)',
              border: '1px solid var(--border-primary)',
              borderRadius: '8px',
              color: 'var(--text-primary)'
            }}
            labelStyle={{ color: 'var(--text-primary)', fontWeight: 600 }}
          />
          <Legend
            verticalAlign="top"
            height={36}
            formatter={(value) => (
              <span style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
                {value}
              </span>
            )}
          />
          <Area
            type="monotone"
            dataKey="shifts"
            name="Car Listings"
            stroke="#F7C948"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorShifts)"
          />
          <Area
            type="monotone"
            dataKey="posts"
            name="Driver Listings"
            stroke="#3B82F6"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorPosts)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ActivityChart;
